/* eslint-disable */
import React from "react";
import { supabase } from "./supabaseClient";

const C = {
  primary:"#1a6b3c", primaryPale:"#e8f5ee", primaryMid:"#6ee7b7",
  amber:"#d97706",   amberPale:"#fffbeb",   amberMid:"#fde68a",
  rose:"#e11d48",    rosePale:"#fef2f2",
  blue:"#2563eb",    bluePale:"#eff6ff",
  purple:"#7c3aed",  purplePale:"#f5f3ff",
  text:"#111827",    muted:"#6b7280",       border:"#d1fae5",
  white:"#ffffff",   bg:"#f9fafb",          shadow:"rgba(0,0,0,0.06)",
};

const RESP_TYPES = [
  {id:"Science Lab",          icon:"🧪"},
  {id:"Computer Lab",         icon:"💻"},
  {id:"Boarding School",      icon:"🏠"},
  {id:"Library",              icon:"📚"},
  {id:"Sports",               icon:"⚽"},
  {id:"Transport",            icon:"🚌"},
  {id:"Discipline Committee", icon:"⚖️"},
  {id:"Exam Committee",       icon:"📝"},
  {id:"Other",                icon:"📌"},
];
const typeIcon = t => (RESP_TYPES.find(r=>r.id===t)||{}).icon || "📌";

// Medium/high severity incidents also land on the staff member's permanent
// Conduct record (staff_conduct, shown in StaffProfile) so it's visible for
// reviews/increments — not just buried in this responsibility's incident log.
const CONDUCT_TYPE_FOR_SEVERITY = { medium: "warning", high: "disciplinary" };

const SEVERITY_META = {
  low:    { label:"Low",    bg:"#f3f4f6", fg:"#4b5563", bd:"#e5e7eb" },
  medium: { label:"Medium", bg:C.amberPale, fg:C.amber, bd:"#fde68a" },
  high:   { label:"High",   bg:C.rosePale,  fg:C.rose,  bd:"#fecaca" },
};

const todayStr = () => new Date().toISOString().split("T")[0];
const fmt = d => d ? new Date(d).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"}) : "—";
const fmtDateTime = d => d ? new Date(d).toLocaleString("en-GB",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "—";

function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{position:"fixed",top:20,right:20,zIndex:9999,background:toast.ok?"#f0fdf4":"#fef2f2",color:toast.ok?"#16a34a":"#dc2626",border:`1px solid ${toast.ok?"#bbf7d0":"#fecaca"}`,borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,boxShadow:"0 4px 18px rgba(0,0,0,.15)"}}>
      {toast.msg}
    </div>
  );
}

function StatusBadge({ active, ended_date }) {
  return active
    ? <span style={{background:C.primaryPale,color:C.primary,border:`1px solid ${C.border}`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>🟢 Active</span>
    : <span style={{background:"#f3f4f6",color:C.muted,border:"1px solid #e5e7eb",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>⚪ Ended {ended_date?fmt(ended_date):""}</span>;
}

function AckBadge({ acknowledged }) {
  return acknowledged
    ? <span style={{background:C.bluePale,color:C.blue,border:"1px solid #bfdbfe",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>✅ Acknowledged</span>
    : <span style={{background:C.amberPale,color:C.amber,border:`1px solid ${C.amberMid}`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>⏳ Pending Ack</span>;
}

function IncidentRow({ incident, onResolve }) {
  const [resolving, setResolving] = React.useState(false);
  const [note, setNote] = React.useState("");
  const sev = SEVERITY_META[incident.severity]||SEVERITY_META.low;
  return (
    <div style={{display:"flex",flexDirection:"column",gap:4,padding:"9px 12px",background:C.white,border:`1px solid ${C.border}`,borderRadius:8}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:8,flexWrap:"wrap"}}>
        <span style={{fontSize:12,fontWeight:700,color:C.text}}>{fmt(incident.incident_date)} — {incident.reported_by_name||"Unknown"}</span>
        <div style={{display:"flex",gap:6,alignItems:"center"}}>
          <span style={{background:sev.bg,color:sev.fg,border:`1px solid ${sev.bd}`,borderRadius:6,padding:"1px 8px",fontSize:10,fontWeight:700}}>{sev.label}</span>
          {incident.status==="resolved"
            ? <span style={{background:"#f0fdf4",color:"#16a34a",border:"1px solid #bbf7d0",borderRadius:6,padding:"1px 8px",fontSize:10,fontWeight:700}}>✅ Resolved</span>
            : <span style={{background:C.rosePale,color:C.rose,border:"1px solid #fecaca",borderRadius:6,padding:"1px 8px",fontSize:10,fontWeight:700}}>🔴 Open</span>}
        </div>
      </div>
      <div style={{fontSize:12,color:C.text}}>{incident.description}</div>
      {incident.status==="resolved" && incident.resolution_note && (
        <div style={{fontSize:11,color:C.muted}}>Resolution: {incident.resolution_note}</div>
      )}
      {incident.status==="open" && onResolve && (
        resolving ? (
          <div style={{display:"flex",flexDirection:"column",gap:6,marginTop:2}}>
            <input placeholder="Resolution note (optional)" value={note} onChange={e=>setNote(e.target.value)} autoFocus
              style={{padding:"6px 9px",borderRadius:6,border:`1px solid ${C.border}`,fontSize:12,boxSizing:"border-box"}}/>
            <div style={{display:"flex",justifyContent:"flex-end",gap:6}}>
              <button onClick={()=>{setResolving(false);setNote("");}}
                style={{background:"none",border:`1px solid ${C.border}`,borderRadius:6,padding:"3px 10px",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                Cancel
              </button>
              <button onClick={()=>{onResolve(incident, note.trim()||null); setResolving(false); setNote("");}}
                style={{background:C.primary,color:C.white,border:"none",borderRadius:6,padding:"3px 12px",fontSize:11,fontWeight:700,cursor:"pointer"}}>
                ✅ Confirm Resolved
              </button>
            </div>
          </div>
        ) : (
          <div style={{display:"flex",justifyContent:"flex-end"}}>
            <button onClick={()=>setResolving(true)}
              style={{background:"none",border:`1px solid ${C.border}`,borderRadius:6,padding:"3px 10px",fontSize:11,fontWeight:700,cursor:"pointer",color:C.primary}}>
              Mark Resolved
            </button>
          </div>
        )
      )}
    </div>
  );
}

function IncidentForm({ onSubmit, onCancel }) {
  const [description, setDescription] = React.useState("");
  const [severity, setSeverity] = React.useState("low");
  return (
    <div style={{display:"flex",flexDirection:"column",gap:8,padding:"10px 12px",background:C.bg,border:`1px dashed ${C.border}`,borderRadius:9}}>
      <textarea placeholder="Describe what happened…" value={description} onChange={e=>setDescription(e.target.value)} rows={2}
        style={{padding:"7px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12,boxSizing:"border-box",resize:"vertical"}}/>
      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
        <select value={severity} onChange={e=>setSeverity(e.target.value)}
          style={{padding:"7px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          {Object.keys(SEVERITY_META).map(k=><option key={k} value={k}>{SEVERITY_META[k].label} severity</option>)}
        </select>
        <div style={{flex:1}}/>
        <button onClick={onCancel} style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={()=>{ if(!description.trim()) return; onSubmit({description:description.trim(),severity}); }}
          style={{background:C.rose,color:C.white,border:"none",borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
          Report Incident
        </button>
      </div>
    </div>
  );
}

// ── Teacher / staff self-service tab ──────────────────────────────────────
export function StaffResponsibilityTab({ teacher }) {
  const [items, setItems] = React.useState([]);
  const [incidentsByResp, setIncidentsByResp] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [toast, setToast] = React.useState(null);
  const [expanded, setExpanded] = React.useState(null);
  const [reportingFor, setReportingFor] = React.useState(null);
  const [ackText, setAckText] = React.useState({});

  const showToast = (msg,ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),3000); };

  const load = React.useCallback(async () => {
    setLoading(true);
    const { data: rows } = await supabase.from("staff_responsibilities").select("*")
      .eq("staff_name", teacher.name).order("assigned_date",{ascending:false});
    setItems(rows||[]);
    if ((rows||[]).length) {
      const { data: incRows } = await supabase.from("responsibility_incidents").select("*")
        .in("responsibility_id", rows.map(r=>r.id)).order("incident_date",{ascending:false});
      const grouped = {};
      (incRows||[]).forEach(i => { (grouped[i.responsibility_id] ||= []).push(i); });
      setIncidentsByResp(grouped);
    } else {
      setIncidentsByResp({});
    }
    setLoading(false);
  }, [teacher.name]);

  React.useEffect(()=>{ load(); }, [load]);

  const acknowledge = async (item) => {
    const text = (ackText[item.id]||"").trim() || null;
    const payload = { acknowledged:true, acknowledged_at:new Date().toISOString(), acknowledgement_text:text };
    const { error } = await supabase.from("staff_responsibilities").update(payload).eq("id",item.id);
    if (error) { showToast("Error: "+error.message, false); return; }
    setItems(p=>p.map(x=>x.id===item.id?{...x,...payload}:x));
    showToast("Responsibility acknowledged.");
  };

  const reportIncident = async (item, form) => {
    const { data, error } = await supabase.from("responsibility_incidents").insert({
      responsibility_id: item.id, reported_by: teacher.staff_id||null, reported_by_name: teacher.name,
      description: form.description, severity: form.severity,
    }).select().single();
    if (error) { showToast("Error: "+error.message, false); return; }
    setIncidentsByResp(p=>({...p,[item.id]:[data,...(p[item.id]||[])]}));
    setReportingFor(null);
    showToast("Incident reported.");
  };

  const active = items.filter(i=>i.is_active);
  const ended  = items.filter(i=>!i.is_active);

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <Toast toast={toast}/>
      <div style={{background:C.white,borderRadius:14,padding:"18px 22px",border:`1px solid ${C.border}`,boxShadow:`0 2px 10px ${C.shadow}`}}>
        <div style={{fontWeight:900,fontSize:17,color:C.primary,marginBottom:4}}>🗂️ My Duties & Responsibilities</div>
        <div style={{fontSize:12,color:C.muted}}>Extra duties assigned to you beyond your subject — acknowledge them and log any incidents.</div>
      </div>

      {loading && <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div>}
      {!loading && items.length===0 && (
        <div style={{background:C.white,borderRadius:12,padding:30,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
          No extra duties assigned to you yet.
        </div>
      )}

      {[...active, ...ended].map(item => {
        const open = expanded===item.id;
        const incidents = incidentsByResp[item.id]||[];
        const openIncidents = incidents.filter(i=>i.status==="open").length;
        return (
          <div key={item.id} style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,overflow:"hidden"}}>
            <div onClick={()=>setExpanded(open?null:item.id)}
              style={{padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap",cursor:"pointer"}}>
              <div>
                <div style={{fontWeight:800,fontSize:14,color:C.text}}>{typeIcon(item.responsibility_type)} {item.title || item.responsibility_type}</div>
                <div style={{fontSize:11,color:C.muted}}>{item.responsibility_type} · since {fmt(item.assigned_date)}</div>
              </div>
              <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                {openIncidents>0 && <span style={{background:C.rosePale,color:C.rose,border:"1px solid #fecaca",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>⚠️ {openIncidents} open</span>}
                <AckBadge acknowledged={item.acknowledged}/>
                <StatusBadge active={item.is_active} ended_date={item.ended_date}/>
                <span style={{fontSize:13,color:C.muted}}>{open?"▲":"▼"}</span>
              </div>
            </div>
            {open && (
              <div style={{padding:"0 18px 18px",display:"flex",flexDirection:"column",gap:8}}>
                {item.notes && <div style={{fontSize:12,color:C.muted}}>Note from admin: {item.notes}</div>}
                {!item.acknowledged && item.is_active && (
                  <div style={{display:"flex",flexDirection:"column",gap:8,padding:"10px 12px",background:C.amberPale,border:`1px solid ${C.amberMid}`,borderRadius:9}}>
                    <div style={{fontSize:12,fontWeight:700,color:C.amber}}>Please acknowledge this responsibility</div>
                    <input placeholder="Optional comment" value={ackText[item.id]||""} onChange={e=>setAckText(p=>({...p,[item.id]:e.target.value}))}
                      style={{padding:"7px 10px",borderRadius:7,border:`1px solid ${C.amberMid}`,fontSize:12,boxSizing:"border-box"}}/>
                    <div style={{display:"flex",justifyContent:"flex-end"}}>
                      <button onClick={()=>acknowledge(item)}
                        style={{background:C.amber,color:C.white,border:"none",borderRadius:7,padding:"7px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                        ✅ Acknowledge
                      </button>
                    </div>
                  </div>
                )}
                {item.acknowledged && item.acknowledgement_text && (
                  <div style={{fontSize:11,color:C.muted}}>Your note: {item.acknowledgement_text} ({fmtDateTime(item.acknowledged_at)})</div>
                )}

                <div style={{fontSize:12,fontWeight:700,color:C.text,marginTop:6}}>Incident Log</div>
                {incidents.length===0 && <div style={{fontSize:12,color:C.muted}}>No incidents reported.</div>}
                {incidents.map(inc => <IncidentRow key={inc.id} incident={inc}/>)}

                {reportingFor===item.id ? (
                  <IncidentForm onCancel={()=>setReportingFor(null)} onSubmit={(form)=>reportIncident(item,form)}/>
                ) : (
                  <div style={{display:"flex",justifyContent:"flex-end"}}>
                    <button onClick={()=>setReportingFor(item.id)}
                      style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer",color:C.rose}}>
                      ⚠️ Report Incident
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── Admin form to assign a new responsibility ─────────────────────────────
function AssignForm({ staffList, onAssign, onCancel }) {
  const [form, setForm] = React.useState({ staff_id:"", responsibility_type:RESP_TYPES[0].id, title:"", notes:"" });
  const set = (k,v) => setForm(p=>({...p,[k]:v}));
  const submit = () => {
    if (!form.staff_id) return;
    const staff = staffList.find(s=>s.id===form.staff_id);
    onAssign({ ...form, staff_name: staff?.name||"" });
  };
  return (
    <div style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,padding:16,display:"flex",flexDirection:"column",gap:10}}>
      <div style={{fontWeight:800,fontSize:14,color:C.text}}>Assign New Responsibility</div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <select value={form.staff_id} onChange={e=>set("staff_id",e.target.value)}
          style={{flex:1,minWidth:160,padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          <option value="">Select staff member…</option>
          {staffList.map(s=><option key={s.id} value={s.id}>{s.name} ({s.role})</option>)}
        </select>
        <select value={form.responsibility_type} onChange={e=>set("responsibility_type",e.target.value)}
          style={{padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          {RESP_TYPES.map(t=><option key={t.id} value={t.id}>{t.icon} {t.id}</option>)}
        </select>
      </div>
      <input placeholder="Title (optional, e.g. 'Lab In-Charge')" value={form.title} onChange={e=>set("title",e.target.value)}
        style={{padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12,boxSizing:"border-box"}}/>
      <input placeholder="Notes for the staff member (optional)" value={form.notes} onChange={e=>set("notes",e.target.value)}
        style={{padding:"8px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12,boxSizing:"border-box"}}/>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
        <button onClick={onCancel} style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"8px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={submit} disabled={!form.staff_id}
          style={{background:form.staff_id?C.primary:"#9ca3af",color:C.white,border:"none",borderRadius:7,padding:"8px 18px",fontSize:12,fontWeight:700,cursor:form.staff_id?"pointer":"not-allowed"}}>
          Assign
        </button>
      </div>
    </div>
  );
}

function ReassignForm({ staffList, current, onReassign, onCancel }) {
  const [staffId, setStaffId] = React.useState("");
  const [note, setNote] = React.useState("");
  const options = staffList.filter(s=>s.id!==current.staff_id);
  return (
    <div style={{display:"flex",flexDirection:"column",gap:8,padding:"10px 12px",background:C.bg,border:`1px dashed ${C.border}`,borderRadius:9}}>
      <div style={{fontSize:12,fontWeight:700,color:C.text}}>Reassign "{current.title||current.responsibility_type}" to:</div>
      <select value={staffId} onChange={e=>setStaffId(e.target.value)}
        style={{padding:"7px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
        <option value="">Select new staff member…</option>
        {options.map(s=><option key={s.id} value={s.id}>{s.name} ({s.role})</option>)}
      </select>
      <input placeholder="Handover checklist / note (optional)" value={note} onChange={e=>setNote(e.target.value)}
        style={{padding:"7px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12,boxSizing:"border-box"}}/>
      <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
        <button onClick={onCancel} style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>Cancel</button>
        <button onClick={()=>{ if(!staffId) return; const s=staffList.find(x=>x.id===staffId); onReassign(s,note.trim()||null); }}
          disabled={!staffId}
          style={{background:staffId?C.purple:"#9ca3af",color:C.white,border:"none",borderRadius:7,padding:"7px 16px",fontSize:12,fontWeight:700,cursor:staffId?"pointer":"not-allowed"}}>
          🔁 Confirm Handover
        </button>
      </div>
    </div>
  );
}

// ── Admin view ──────────────────────────────────────────────────────────────
export function StaffResponsibilityAdmin() {
  const [items, setItems] = React.useState([]);
  const [incidentsByResp, setIncidentsByResp] = React.useState({});
  const [staffList, setStaffList] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [toast, setToast] = React.useState(null);
  const [showAssignForm, setShowAssignForm] = React.useState(false);
  const [typeFilter, setTypeFilter] = React.useState("all");
  const [statFilter, setStatFilter] = React.useState("active"); // "active" | "incidents" | "unack" | null
  const [expanded, setExpanded] = React.useState(null);
  const [reportingFor, setReportingFor] = React.useState(null);
  const [reassigningFor, setReassigningFor] = React.useState(null);
  const [endingFor, setEndingFor] = React.useState(null);

  const showToast = (msg,ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),3000); };

  const load = React.useCallback(async () => {
    setLoading(true);
    const [{ data: staffRows }, { data: rows }] = await Promise.all([
      supabase.from("staff").select("id,name,role").eq("status","Active").order("name"),
      supabase.from("staff_responsibilities").select("*").order("assigned_date",{ascending:false}),
    ]);
    setStaffList(staffRows||[]);
    setItems(rows||[]);
    if ((rows||[]).length) {
      const { data: incRows } = await supabase.from("responsibility_incidents").select("*")
        .in("responsibility_id", rows.map(r=>r.id)).order("incident_date",{ascending:false});
      const grouped = {};
      (incRows||[]).forEach(i => { (grouped[i.responsibility_id] ||= []).push(i); });
      setIncidentsByResp(grouped);
    } else {
      setIncidentsByResp({});
    }
    setLoading(false);
  }, []);

  React.useEffect(()=>{ load(); }, [load]);

  const assign = async (form) => {
    const { data, error } = await supabase.from("staff_responsibilities").insert({
      staff_id: form.staff_id, staff_name: form.staff_name, responsibility_type: form.responsibility_type,
      title: form.title||null, notes: form.notes||null, assigned_by_name: "Admin",
    }).select().single();
    if (error) { showToast("Error: "+error.message, false); return; }
    setItems(p=>[data,...p]);
    setShowAssignForm(false);
    showToast("Responsibility assigned.");
  };

  const endAssignment = async (item) => {
    const payload = { is_active:false, ended_date: todayStr() };
    const { error } = await supabase.from("staff_responsibilities").update(payload).eq("id",item.id);
    if (error) { showToast("Error: "+error.message, false); return; }
    setItems(p=>p.map(x=>x.id===item.id?{...x,...payload}:x));
    setEndingFor(null);
    showToast("Assignment ended.");
  };

  const reportIncident = async (item, form) => {
    const { data, error } = await supabase.from("responsibility_incidents").insert({
      responsibility_id: item.id, reported_by_name: "Admin", description: form.description, severity: form.severity,
    }).select().single();
    if (error) { showToast("Error: "+error.message, false); return; }
    setIncidentsByResp(p=>({...p,[item.id]:[data,...(p[item.id]||[])]}));
    setReportingFor(null);

    const conductType = CONDUCT_TYPE_FOR_SEVERITY[form.severity];
    if (conductType) {
      await supabase.from("staff_conduct").insert({
        staff_id: item.staff_id, staff_name: item.staff_name, date: todayStr(), type: conductType,
        title: `${item.responsibility_type} duty — ${form.severity} severity incident`,
        body: form.description, added_by: "Admin (via Staff Responsibilities)",
      });
      showToast(`Incident reported — also added to ${item.staff_name}'s conduct record.`);
    } else {
      showToast("Incident reported.");
    }
  };

  const resolveIncident = async (incident, note) => {
    const payload = { status:"resolved", resolved_at:new Date().toISOString(), resolution_note:note||null };
    const { error } = await supabase.from("responsibility_incidents").update(payload).eq("id",incident.id);
    if (error) { showToast("Error: "+error.message, false); return; }
    setIncidentsByResp(p=>({...p,[incident.responsibility_id]:(p[incident.responsibility_id]||[]).map(i=>i.id===incident.id?{...i,...payload}:i)}));
    showToast("Incident resolved.");
  };

  const reassign = async (item, newStaff, note) => {
    const { error: e1 } = await supabase.from("staff_responsibilities").update({ is_active:false, ended_date:todayStr() }).eq("id",item.id);
    if (e1) { showToast("Error: "+e1.message, false); return; }
    const { data: newItem, error: e2 } = await supabase.from("staff_responsibilities").insert({
      staff_id: newStaff.id, staff_name: newStaff.name, responsibility_type: item.responsibility_type,
      title: item.title, notes: item.notes, assigned_by_name: "Admin",
    }).select().single();
    if (e2) { showToast("Error: "+e2.message, false); return; }
    await supabase.from("responsibility_handovers").insert({
      responsibility_id: item.id, outgoing_staff_id: item.staff_id, outgoing_staff_name: item.staff_name,
      incoming_staff_id: newStaff.id, incoming_staff_name: newStaff.name, checklist_note: note,
    });
    setItems(p=>[newItem, ...p.map(x=>x.id===item.id?{...x,is_active:false,ended_date:todayStr()}:x)]);
    setReassigningFor(null);
    showToast(`Handed over to ${newStaff.name}.`);
  };

  const openIncidentsFor = (item) => (incidentsByResp[item.id]||[]).filter(i=>i.status==="open").length;

  const activeCount = items.filter(i=>i.is_active).length;
  const openIncidentCount = Object.values(incidentsByResp).flat().filter(i=>i.status==="open").length;
  const unackCount = items.filter(i=>i.is_active && !i.acknowledged).length;

  const filtered = items.filter(i => {
    if (typeFilter!=="all" && i.responsibility_type!==typeFilter) return false;
    if (statFilter==="active" && !i.is_active) return false;
    if (statFilter==="incidents" && openIncidentsFor(i)===0) return false;
    if (statFilter==="unack" && !(i.is_active && !i.acknowledged)) return false;
    return true;
  });

  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <Toast toast={toast}/>
      <div style={{background:C.white,borderRadius:14,padding:"18px 22px",border:`1px solid ${C.border}`,boxShadow:`0 2px 10px ${C.shadow}`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10,marginBottom:14}}>
          <div>
            <div style={{fontWeight:900,fontSize:17,color:C.primary,marginBottom:4}}>🗂️ Staff Responsibilities</div>
            <div style={{fontSize:12,color:C.muted}}>Assign extra duties (labs, boarding, library…) and track accountability.</div>
          </div>
          {!showAssignForm && <button onClick={()=>setShowAssignForm(true)}
            style={{background:C.primary,color:C.white,border:"none",borderRadius:9,padding:"9px 18px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
            + Assign Responsibility
          </button>}
        </div>

        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:showAssignForm?14:0}}>
          {[
            {key:"active",    icon:"🟢",label:"Active Assignments",       val:activeCount,        col:C.primary, bg:C.primaryPale},
            {key:"incidents", icon:"🔴",label:"Open Incidents",            val:openIncidentCount,  col:C.rose,    bg:C.rosePale},
            {key:"unack",     icon:"⏳",label:"Pending Acknowledgement",   val:unackCount,          col:C.amber,   bg:C.amberPale},
          ].map(({key,icon,label,val,col,bg})=>{
            const on = statFilter===key;
            return (
              <button key={key} onClick={()=>setStatFilter(on?null:key)} title="Click to filter the list below"
                style={{background:bg,borderRadius:10,padding:"8px 14px",display:"flex",alignItems:"center",gap:9,
                  border:`1px solid ${on?col:col+"20"}`, boxShadow:on?`0 0 0 2px ${col}40`:"none",
                  cursor:"pointer", textAlign:"left", fontFamily:"inherit"}}>
                <span style={{fontSize:18}}>{icon}</span>
                <div>
                  <div style={{fontWeight:900,fontSize:20,color:col,lineHeight:1}}>{val}</div>
                  <div style={{fontSize:10,color:C.muted,fontWeight:600,textTransform:"uppercase",letterSpacing:.3}}>{label}</div>
                </div>
              </button>
            );
          })}
          {statFilter && <button onClick={()=>setStatFilter(null)}
            style={{background:"none",border:`1px solid ${C.border}`,borderRadius:10,padding:"8px 14px",fontSize:12,fontWeight:700,color:C.muted,cursor:"pointer"}}>
            ✕ Clear filter
          </button>}
        </div>

        {showAssignForm && <div style={{marginTop:14}}><AssignForm staffList={staffList} onAssign={assign} onCancel={()=>setShowAssignForm(false)}/></div>}
      </div>

      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
        <select value={typeFilter} onChange={e=>setTypeFilter(e.target.value)}
          style={{padding:"7px 10px",borderRadius:7,border:`1px solid ${C.border}`,fontSize:12}}>
          <option value="all">All types</option>
          {RESP_TYPES.map(t=><option key={t.id} value={t.id}>{t.icon} {t.id}</option>)}
        </select>
        {statFilter && <span style={{fontSize:11,color:C.muted}}>Filtered by: {statFilter==="active"?"Active Assignments":statFilter==="incidents"?"Open Incidents":"Pending Acknowledgement"}</span>}
      </div>

      {loading && <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div>}
      {!loading && filtered.length===0 && (
        <div style={{background:C.white,borderRadius:12,padding:30,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
          No responsibilities match this filter.
        </div>
      )}

      {filtered.map(item => {
        const open = expanded===item.id;
        const incidents = incidentsByResp[item.id]||[];
        const openIncidents = incidents.filter(i=>i.status==="open").length;
        return (
          <div key={item.id} style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,overflow:"hidden"}}>
            <div onClick={()=>setExpanded(open?null:item.id)}
              style={{padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:10,flexWrap:"wrap",cursor:"pointer"}}>
              <div>
                <div style={{fontWeight:800,fontSize:14,color:C.text}}>{typeIcon(item.responsibility_type)} {item.staff_name} — {item.title||item.responsibility_type}</div>
                <div style={{fontSize:11,color:C.muted}}>{item.responsibility_type} · since {fmt(item.assigned_date)}</div>
              </div>
              <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
                {openIncidents>0 && <span style={{background:C.rosePale,color:C.rose,border:"1px solid #fecaca",borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>⚠️ {openIncidents} open</span>}
                <AckBadge acknowledged={item.acknowledged}/>
                <StatusBadge active={item.is_active} ended_date={item.ended_date}/>
                <span style={{fontSize:13,color:C.muted}}>{open?"▲":"▼"}</span>
              </div>
            </div>
            {open && (
              <div style={{padding:"0 18px 18px",display:"flex",flexDirection:"column",gap:8}}>
                {item.notes && <div style={{fontSize:12,color:C.muted}}>Notes: {item.notes}</div>}
                {item.acknowledged && item.acknowledgement_text && (
                  <div style={{fontSize:11,color:C.muted}}>Staff note: {item.acknowledgement_text} ({fmtDateTime(item.acknowledged_at)})</div>
                )}

                <div style={{fontSize:12,fontWeight:700,color:C.text,marginTop:6}}>Incident Log</div>
                {incidents.length===0 && <div style={{fontSize:12,color:C.muted}}>No incidents reported.</div>}
                {incidents.map(inc => <IncidentRow key={inc.id} incident={inc} onResolve={resolveIncident}/>)}

                {reportingFor===item.id ? (
                  <IncidentForm onCancel={()=>setReportingFor(null)} onSubmit={(form)=>reportIncident(item,form)}/>
                ) : reassigningFor===item.id ? (
                  <ReassignForm staffList={staffList} current={item} onCancel={()=>setReassigningFor(null)} onReassign={(s,note)=>reassign(item,s,note)}/>
                ) : endingFor===item.id ? (
                  <div style={{display:"flex",flexDirection:"column",gap:8,padding:"10px 12px",background:C.rosePale,border:"1px solid #fecaca",borderRadius:9}}>
                    <div style={{fontSize:12,color:C.text}}>
                      End <b>"{item.title||item.responsibility_type}"</b> for <b>{item.staff_name}</b>? This stops their active assignment as of today.
                    </div>
                    <div style={{display:"flex",justifyContent:"flex-end",gap:8}}>
                      <button onClick={()=>setEndingFor(null)}
                        style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                        Cancel
                      </button>
                      <button onClick={()=>endAssignment(item)}
                        style={{background:C.rose,color:C.white,border:"none",borderRadius:7,padding:"7px 16px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                        🛑 Confirm End
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{display:"flex",justifyContent:"flex-end",gap:8,flexWrap:"wrap"}}>
                    <button onClick={()=>setReportingFor(item.id)}
                      style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer",color:C.rose}}>
                      ⚠️ Report Incident
                    </button>
                    {item.is_active && (
                      <>
                        <button onClick={()=>setReassigningFor(item.id)}
                          style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer",color:C.purple}}>
                          🔁 Reassign
                        </button>
                        <button onClick={()=>setEndingFor(item.id)}
                          style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer",color:C.muted}}>
                          🛑 End Assignment
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
